export default __webpack_public_path__ + "static/media/num-3.efc6d9b3.svg";